<template>
  <img
    class="no-avatar"
    v-if="!isAvatar"
    src="@/assets/svg/user.svg"
    style="width: 35px; height: 35px"
  >
</template>

<script>
export default {
  props: {
    isAvatar: {
      type: Boolean,
      default: false
    }
  }
};
</script>